export function normalize(s) {
    return s?.replaceAll(' ', '')?.toLowerCase();
}

export const trimName = (name) => {
    if (!name) return '';
    
    const parts = name.split(' ');
    if (parts.length < 2) return name;
    
    const lastName = parts[0];
    const initials = parts.slice(1).map(word => word[0] + '.').join(' ');
    
    return `${lastName} ${initials}`;
  };
  